module.exports = __webpack_public_path__ + "img/recommended_05.c0e5dff0.webp";